import React, { ReactElement } from 'react';
import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useFeatureFlag } from 'modules/common/hooks';
import { useMessage } from 'modules/intl';
import { ReactComponent as TI500Icon } from './icons/TimeIntelligence_500_Icon.svg';
import { useGoToHome } from './hooks/useGoToHome';
import { ErrorPageType } from './types';
import { useErrorPageStyles } from './hooks/useErrorPageStyles';
import ZeroTime_Logo_Error_Pages from './logo/ZeroTime_Logo_Error_Pages.svg';

const ErrorPage_500 = ({ ecid }: ErrorPageType): ReactElement => {
  const classes = useErrorPageStyles();
  const { goToHome } = useGoToHome();

  const errorLogoMsg = useMessage('notFoundPage.errorIcon500');
  const zeroTimeLogo = useMessage('zeroTimeLogo');
  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');

  return (
    <div data-testid="error-page-500" className={classes.root}>
      <img
        src={ZeroTime_Logo_Error_Pages}
        alt={isTiwScreenReaderEnabled ? zeroTimeLogo : 'Zt Logo'}
      />

      <TI500Icon
        className={classes.icon}
        aria-label={isTiwScreenReaderEnabled ? errorLogoMsg : ''}
      />
      <Typography variant="h2" className={classes.titleText}>
        <FormattedMessage id="errorPage._500.title" />
      </Typography>
      <Typography variant="h6" className={classes.subTitleText}>
        <FormattedMessage id="errorPage._500.subText" />
      </Typography>
      <Button
        className={classes.button}
        color="primary"
        variant="contained"
        onClick={goToHome}
        size="large"
      >
        <FormattedMessage id="errorPage._500.buttonText" />
      </Button>
      <Typography variant="body1" data-testid="ecid-container">
        <span className={classes.trace}>
          <FormattedMessage id="errorPage.traceIdLabel" />
        </span>{' '}
        {ecid}
      </Typography>
    </div>
  );
};

export default ErrorPage_500;
